export default __webpack_public_path__ + "static/media/pdf-icon.a495b52d.png";